import { useEffect, useRef, useState } from "react";

export default function OTPInput({ length, onOtpSubmit, onChange }) {
  const [value, setValue] = useState("");
  const inputRef = useRef(null);

  const handleChange = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, length);
    setValue(val);
    if (onChange) {
      onChange(val);
    }
    if (val.length === length && onOtpSubmit) {
      onOtpSubmit(val);
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }

    if ("OTPCredential" in window) {
      const ac = new AbortController();
      navigator.credentials
        .get({
          otp: { transport: ["sms"] },
          signal: ac.signal,
        })
        .then((otpCredential) => {
          const code = otpCredential.code;
          if (code && code.length === length) {
            setValue(code);
            if (onChange) {
              onChange(code);
            }
            if (onOtpSubmit) {
              onOtpSubmit(code);
            }
          }
        })
        .catch((err) => {
          console.warn("WebOTP API error:", err);
        });

      return () => {
        ac.abort();
      };
    }
  }, [length]);

  const boxes = new Array(length).fill("");

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <input
        ref={inputRef}
        type="tel"
        pattern={`\\d{${length}}`}
        inputMode="numeric"
        autoComplete="one-time-code"
        value={value}
        onChange={handleChange}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          opacity: 0,
          fontSize: "16px", // Prevents iOS zoom
          zIndex: 2,
          cursor: "pointer",
        }}
      />
      {/* Visual boxes */}
      <div style={{ display: "flex", pointerEvents: "none" }}>
        {boxes.map((_, index) => {
          const char = value[index] || "";
          const isFocused = value.length === index || (value.length === length && index === length - 1);
          return (
            <div
              key={index}
              style={{
                width: "40px",
                height: "45px",
                margin: "4px 2px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: isFocused ? "2px solid #3095A7" : "1px solid #ccc",
                borderRadius: "4px",
                fontSize: "16px",
                fontWeight: "bold",
                backgroundColor: "#fff",
              }}
            >
              {char}
            </div>
          );
        })}
      </div>
    </div>
  );
}
